import React, { useState } from 'react';
import { submitLead } from '@/lib/api';
import { toast } from 'sonner';
import { ArrowRight, Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const MiniForm = ({ sourcePage = '/', topic = '', className = '' }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const fd = new FormData(e.target);
    try {
      await submitLead({
        name: fd.get('name'),
        email: fd.get('email'),
        industry: fd.get('industry'),
        source_page: sourcePage,
        topic: topic || undefined,
        form_type: 'mini',
        honeypot: fd.get('website') || '',
      });
      toast.success('Mensaje enviado correctamente');
      navigate('/gracias');
    } catch {
      toast.error('Error al enviar. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`space-y-3 ${className}`} data-testid="lead-mini-form" aria-label="Formulario de contacto rápido">
      <input type="text" name="website" className="hidden" tabIndex={-1} autoComplete="off" aria-hidden="true" />
      <input name="name" placeholder="Nombre" required aria-label="Nombre" className="w-full px-4 py-3 text-sm bg-white border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0EA5E9]/30 focus:border-[#0EA5E9] transition-colors text-slate-900" />
      <input name="email" type="email" placeholder="Email corporativo" required aria-label="Email corporativo" className="w-full px-4 py-3 text-sm bg-white border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0EA5E9]/30 focus:border-[#0EA5E9] transition-colors text-slate-900" />
      <select name="industry" aria-label="Industria" className="w-full px-4 py-3 text-sm bg-white border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0EA5E9]/30 focus:border-[#0EA5E9] transition-colors text-slate-900">
        <option value="">Industria</option>
        <option value="retail">Retail</option>
        <option value="banca">Banca</option>
        <option value="salud">Salud</option>
        <option value="mineria">Minería</option>
        <option value="aeropuertos">Aeropuertos</option>
        <option value="sector-publico">Sector Público</option>
        <option value="otro">Otro</option>
      </select>
      <button type="submit" disabled={loading} className="w-full flex items-center justify-center gap-2 px-5 py-3 text-sm font-semibold text-white bg-[#0EA5E9] rounded-xl hover:bg-sky-600 shadow-lg disabled:opacity-50 transition-all" data-testid="lead-mini-form-submit">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><span>Agendar Demo</span><ArrowRight className="w-4 h-4" /></>}
      </button>
    </form>
  );
};

export const EnterpriseForm = ({ sourcePage = '/', topic = '', prefilledMessage = '', className = '' }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const fd = new FormData(e.target);
    const lastName = fd.get('lastName') || '';
    try {
      await submitLead({
        name: `${fd.get('firstName')}${lastName ? ' ' + lastName : ''}`.trim(),
        email: fd.get('email'),
        phone: fd.get('phone') || '',
        company: fd.get('company') || '',
        message: fd.get('message') || '',
        source_page: sourcePage,
        topic: topic || undefined,
        form_type: 'enterprise',
        honeypot: fd.get('website') || '',
      });
      toast.success('Solicitud enviada correctamente');
      navigate('/gracias');
    } catch {
      toast.error('Error al enviar. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  const inputClass = 'w-full px-4 py-3 text-sm bg-white border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0EA5E9]/30 focus:border-[#0EA5E9] transition-colors text-slate-900';

  return (
    <form onSubmit={handleSubmit} className={`space-y-4 ${className}`} data-testid="lead-enterprise-form" aria-label="Formulario de cotización empresarial">
      <input type="text" name="website" className="hidden" tabIndex={-1} autoComplete="off" aria-hidden="true" />
      {topic && <input type="hidden" name="topic" value={topic} data-testid="lead-form-topic-hidden" />}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input name="firstName" placeholder="Nombre" required aria-label="Nombre" className={inputClass} />
        <input name="lastName" placeholder="Apellido" aria-label="Apellido" className={inputClass} />
        <input name="email" type="email" placeholder="Email corporativo" required aria-label="Email" className={inputClass} />
        <input name="phone" type="tel" placeholder="Teléfono" aria-label="Teléfono" className={inputClass} />
      </div>
      <input name="company" placeholder="Empresa" aria-label="Empresa" className={inputClass} />
      <textarea name="message" rows="3" placeholder="Cuéntanos sobre tu proyecto..." defaultValue={prefilledMessage} aria-label="Mensaje" className={inputClass}></textarea>
      <button type="submit" disabled={loading} className="w-full sm:w-auto flex items-center justify-center gap-2 px-8 py-3 text-sm font-semibold text-white bg-[#0EA5E9] rounded-xl hover:bg-sky-600 shadow-lg disabled:opacity-50 transition-all" data-testid="lead-enterprise-form-submit-button">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><span>Enviar Solicitud</span><ArrowRight className="w-4 h-4" /></>}
      </button>
    </form>
  );
};
